var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Icon from '../icon';
import Input from '../input';
import { Styled } from './style';
var GroupInput = /** @class */ (function (_super) {
    __extends(GroupInput, _super);
    function GroupInput(props) {
        var _this = _super.call(this, props) || this;
        _this.removeComponent = function () {
            _this.setState({ unmount: true });
        };
        _this.handlerOnSaveValue = function (e) {
            if (_this.props.onSaved) {
                _this.props.onSaved(e, _this.state.value, _this.props.id);
            }
        };
        _this.saveValue = function (e, target) {
            _this.setState({ value: target.value });
        };
        _this.enableEditMode = function () {
            _this.setState({ editmode: true });
        };
        _this.disableEditMode = function () {
            _this.setState({ editmode: false });
        };
        _this.handlerKeyDown = function (event) {
            var key = event.key, value = event.currentTarget.value;
            if (key === 'Enter') {
                _this.setState({ value: value }, function () {
                    _this.handlerOnSaveValue(event);
                });
            }
        };
        _this.onSelectedGroupChange = function () {
            if (_this.props.id) {
                _this.props.onSelectAllScreenInGroup && _this.props.onSelectAllScreenInGroup(_this.props.selectedScreens && _this.props.selectedScreens > 0 ? false : true, _this.props.id);
            }
        };
        _this.state = {
            editmode: _this.props.editmode,
            unmount: _this.props.unmount,
            value: _this.props.value,
        };
        return _this;
    }
    GroupInput.prototype.render = function () {
        var value = this.state.value;
        var _a = this.props, autoFocus = _a.autoFocus, placeholder = _a.placeholder, totalScreen = _a.totalScreen, totalSuspended = _a.totalSuspended, totalPause = _a.totalPause, disabled = _a.disabled;
        var nameInput = (React.createElement(Input, { autoFocus: autoFocus, disabled: disabled, placeholder: placeholder, onBlur: this.handlerOnSaveValue, onChange: this.saveValue, defaultValue: this.state.value, onKeyDown: this.handlerKeyDown }));
        var pauseIcon = totalPause ? React.createElement(Icon, { name: "circle", className: "pause-status" }) : null;
        var pauseNumber = totalPause ? React.createElement("span", null, totalPause) : null;
        var suspendedIcon = totalSuspended ? React.createElement(Icon, { name: "circle", className: "suspended-status" }) : null;
        var suspendedNumber = totalSuspended ? React.createElement("span", null, totalSuspended) : null;
        var component = (React.createElement(Styled, { "data-qa": "group-input", title: value },
            React.createElement(React.Fragment, null,
                nameInput,
                React.createElement("div", { className: "notification-container " + (this.props.id && this.props.totalScreen && Number(this.props.totalScreen) > 0 ? 'selectable' : ''), onClick: this.onSelectedGroupChange },
                    React.createElement(Icon, { name: "screen" }),
                    React.createElement("span", null, totalScreen),
                    pauseIcon,
                    pauseNumber,
                    suspendedIcon,
                    suspendedNumber))));
        return this.state.unmount ? null : component;
    };
    GroupInput.defaultProps = {
        value: '',
        totalScreen: '0',
        placeholder: '',
        editmode: false,
        unmount: false,
        disabled: false,
    };
    return GroupInput;
}(React.Component));
export default GroupInput;
//# sourceMappingURL=index.js.map